import { render } from "./twelvePage.vue?vue&type=template&id=033905d4&scoped=true"
import script from "./twelvePage.vue?vue&type=script&lang=js"
export * from "./twelvePage.vue?vue&type=script&lang=js"

import "./twelvePage.vue?vue&type=style&index=0&id=033905d4&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033905d4"]])

export default __exports__